import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import AppLogo from '@/components/ui/AppLogo/AppLogo';
import SearchIcon from '@mui/icons-material/Search';
import { cn } from '@/utils/classNames';

interface NavItem {
  icon: ReactNode;
  onClick?: () => void;
  active?: boolean;
}

interface NavbarProps {
  logoLink: string;
  showLogo?: boolean;
  showSearch?: boolean;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  rightContent?: ReactNode;
  className?: string;
  variant?: string;
  navItems?: NavItem[];
}

const Navbar: FC<NavbarProps> = ({
  logoLink,
  showLogo = true,
  showSearch = true,
  searchQuery = '',
  onSearchChange,
  className,
  navItems = [],
}) => {

  const hasTopContent = showLogo || showSearch;

  return (
    <nav className={cn(
      "flex lg:flex-col lg:items-center gap-6 lg:px-4 lg:py-10 lg:w-[122px] lg:min-w-[122px] lg:bg-white max-h-[100dvh] sticky top-0 z-10",
      hasTopContent ? "px-[22px] py-[20px]" : "hidden lg:flex",
      className
    )}>
      {hasTopContent && (
        <div className="flex flex-row lg:flex-col justify-between lg:justify-start items-center gap-4 w-full lg:w-auto">
          {showLogo && (
            <Link to={logoLink}>
              <AppLogo.Default className="w-[58px]" />
            </Link>
          )}
          {showSearch && (
            <div className="relative w-[186px] lg:hidden">
              <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 !w-5 !h-5" />
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => onSearchChange?.(e.target.value)}
                className="w-full h-[40px] pl-12 pr-4 rounded-full bg-white text-gray-800 placeholder-gray-500 focus:outline-none"
              />
            </div>
          )}
        </div>
      )}

      {navItems.length > 0 && (
        <div className="hidden lg:flex flex-col items-center gap-4 flex-1 justify-center">
          {navItems.map((item, index) => (
            <button
              key={index}
              onClick={item.onClick}
              className={cn(
                "flex items-center justify-center w-10 h-10 rounded-xl transition-colors",
                item.active ? "text-[#FE7062]" : "text-[#1F2937A6] hover:text-[#FE7062]"
              )}
            >
              {item.icon}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
